import { baseApi } from './baseApi.ts';
import type { AccountDto } from '@/app/common/types/account.ts';
import type { PagedResult } from '@/app/common/types/paged-result.ts';
import type { PlanDto } from '@/app/common/types/subscription.ts';
import type { AccountUsageInfoDto } from '@/app/common/types/account-usage.ts';

export const accountApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    listAccounts: builder.query<PagedResult<AccountDto>, void>({
      query: () => 'accounts',
      providesTags: ['Account'],
    }),
    getAccount: builder.query<AccountDto, number>({
      query: (id) => `accounts/${id}`,
      providesTags: (_result, _error, id) => [{ type: 'Account', id }],
    }),
    updateAccount: builder.mutation<AccountDto, Partial<AccountDto> & { id: number }>({
      query: (account) => ({ url: `accounts/${account.id}`, method: 'PUT', body: account }),
      invalidatesTags: ['Account'],
    }),
    closeAccount: builder.mutation<void, { accountId: number; reason?: string }>({
      query: (body) => ({ url: 'accounts/close', method: 'POST', body }),
      invalidatesTags: ['Account'],
    }),
    getAccountPlan: builder.query<PlanDto, number>({
      query: (accountId) => `accounts/${accountId}/plan`,
      providesTags: (_result, _error, id) => [{ type: 'Subscriptions', id }],
    }),
    getAccountUsage: builder.query<AccountUsageInfoDto, number>({
      query: (accountId) => `accounts/${accountId}/usage`,
      providesTags: ['Account', 'AccountUsers', 'MonitoredSubjects', 'NotificationContacts'],
    }),
  }),
});

export const {
  useListAccountsQuery,
  useLazyListAccountsQuery,
  useGetAccountQuery,
  useLazyGetAccountQuery,
  useUpdateAccountMutation,
  useCloseAccountMutation,
  useGetAccountPlanQuery,
  useGetAccountUsageQuery,
} = accountApi;
